import {delegateEvent} from "../utils/event.delegator";

const {Backbone} = require('backboneAdapter');
import i18n from 'l10n';
import ListGroupView from 'js/views/subscribers.listgroup.view';
import ContactView from 'js/views/subscriber.view';
import TilesView from 'js/views/groups.tiles.view';
import GroupView from 'js/views/group.view';
import GroupInfoView from 'js/views/group.info.view';
import NavBarView from 'js/views/navbar.view';
import FileUploadView from 'js/views/fileupload.view';

export default Backbone.Router.extend({
    routes: {
        'upload': 'uploadFile',
        'paste': 'uploadFile',
        'importFromService/:service': 'importFromService',
        'Group/:id': 'loadGroup',
        ':id': 'loadSubscriber',
        "": "defaultRoute"
    },
    importFromService: function (service) {
        // this.showMainView();
        // this.checkIfNormalEntry();
        this.hideMainView();
        window.sessionStorage.removeItem(service);
        // this.fileUploadView.refreshContacts();
        this.removeAllEvents(this.messageView);
    },
    initialize: function (options) {
        console.info("START");
        this.options = options;
        this.navbar = new NavBarView();

        $('.cancelButton').click(ev => {
            this.promptClosedByUser(ev);
        });

        this.fileUploadView = new FileUploadView({
            el: $("#file-upload-container"),
            model: new Backbone.Model({
                uploadUrl: "/CampaignCloud/Upload"
            })
        });

        delegateEvent(this.navbar, this.fileUploadView, "progress:contactsImport");

        this.listGroupView = new ListGroupView();

        this.tilesView = new TilesView();

        delegateEvent(this.listGroupView, this.tilesView, "createQueryGroup");

        this.listGroupNotCollapsed = [];
    },
    showPrompts: function () {
        $.ajaxDefaultQ({
            url: '/CampaignCloud/ShowPrompts/contacts',
            type: 'get',
            dataType: 'json'
        }).done(function (response) {
            if (response) {
                if (response[0] === true) {
                    var $getMoreContacts = $('#getMoreContacts');
                    $getMoreContacts.html(`${i18n.t("dashboard.getMoreContacts")} <i class="icon-lamp-2 padding5"></i>`);
                    $getMoreContacts.attr('title', i18n.t("dashboard.getMoreContactsTitle"));
                    var $moreContactsPrompt = $('#moreContactsPrompt');
                    $moreContactsPrompt.show();
                    $moreContactsPrompt.css('margin-top', '20px');
                }
            }
        }).fail(function (response) {
            console.log(response);
        });
    },
    uploadFile: function () {
        this.checkIfNormalEntry();
        this.hideMainView();
        this.removeAllEvents(this.messageView);
    },
    checkIfNormalEntry: function () {
        if (!this.normalEntry) {
            this.navigate('', {trigger: true});
            location.reload();
        }
    },
    loadGroup: function (id) {
        console.info("loadGroup");
        this.listGroupView.getLetterTabsAndSubscriptionCounts.cache = {};
        this.listGroupView.fetchVisible.cache = {};
        this.normalEntry = true;
        var self = this;
        this.hideMainView();

        if (this.contactView) {
            this.contactView.$el.empty();
            this.contactView = null;
        }
        this.fileUploadView.show();

        this.groupView = new GroupView({"id": id, postpaid: self.options.isPostPaid});
        this.fileUploadView.listenTo(this.groupView.model, "sync", this.fileUploadView.handleGroupModelChange);
        this.groupInfoView = new GroupInfoView({"id": id, postpaid: self.options.isPostPaid});
    },

    loadSubscriber: function (id) {
        console.info("loadSubscriber");
        this.normalEntry = true;
        this.hideMainView();
        this.fileUploadView.hide();
        $('#moreContactsPrompt').hide();
        if (this.groupView) {
            this.groupView.$el.empty();
            this.groupView = null;
        }

        if (this.groupInfoView) {
            this.groupInfoView.$el.empty();
            this.groupInfoView = null;
        }

        $("#single-subscriber-view").show();
        $("#single-subscriber-container").show();

        this.contactView = new ContactView({id});
    },

    defaultRoute: function () {
        console.info("defaultRoute");
        this.listGroupView.getLetterTabsAndSubscriptionCounts.cache = {};
        this.listGroupView.fetchVisible.cache = {};
        this.showPrompts();
        this.normalEntry = true;
        if (this.contactView) {
            this.contactView.remove();
            this.contactView = null;
            $("#single-subscriber-container").empty();
            $("#single-subscriber-view").html($("<div>").attr("id", "single-subscriber-container").addClass("row"));
        }

        if (this.groupInfoView) {
            this.groupInfoView.$el.empty();
            this.groupInfoView = null;
        }

        if (this.groupView) {
            this.groupView.$el.empty();
            this.groupView = null;
        }
        this.showMainView();
    },

    showMainView: function () {
        var self = this;
        // Must also pass this.listGroupNotCollapsed to reopen non collapsed groups on success
        this.listGroupView.load({listGroupNotCollapsed: this.listGroupNotCollapsed, postpaid: self.options.isPostPaid});
        this.tilesView.load();

        this.fileUploadView.show();
        this.listGroupView.show();
        this.tilesView.show();
        this.fileUploadView.groupIdProperty = null;
        $("#single-subscriber-view").hide();
        if (this.contactView) {
            this.contactView.hide();
        }
    },
    hideMainView: function () {
        this.listGroupView.hide();
        this.tilesView.hide();
        $("#single-subscriber-view").hide();
        if (this.contactView) {
            this.contactView.hide();
        }

        // Keep track of the currently expanded tab, so that you expand the same again, after re-rendering
        var self = this;
        this.listGroupNotCollapsed = [];
        this.listGroupView.$el.find('.list-group').not('.collapsed').each(function () {
            self.listGroupNotCollapsed.push(this.id);
        });
    },

    removeAllEvents: function (view) {
        if (view) {
            view.$el.off();
            view.$el.empty();
            view.undelegateEvents();
            view = null;
        }
    },

    promptClosedByUser: function (event) {
        var data = $(event.currentTarget).parent().parent().data();
        var id = data['id'];
        if (id !== undefined && id === 5) {
            $.ajaxDefaultQ({
                url: '/CampaignCloud/ShowPrompts/' + id,
                type: 'post',
                dataType: 'json'
            }).done(function (response) {
                if (response) {
                    if (response.toClose === true) {
                        $('[data-id=' + response.id + ']').hide();
                    }
                }
            }).fail(function (response) {
                console.log(response);
            });
        }
    }
});
